import React from 'react';

const LoadingSkeleton = ({ type = 'default', count = 1 }) => {
  const baseStyle = {
    background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
    backgroundSize: '200% 100%',
    animation: 'loading 1.5s ease-in-out infinite',
    borderRadius: '8px'
  };

  const renderSkeleton = () => {
    switch (type) {
      case 'table':
        return (
          <div style={{ width: '100%' }}>
            {/* Table header */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(7, 1fr)',
              gap: '1rem',
              padding: '1rem',
              background: '#f5f5f5',
              borderRadius: '10px 10px 0 0'
            }}>
              {Array.from({ length: 7 }).map((_, i) => (
                <div key={i} style={{ ...baseStyle, height: '20px' }} />
              ))}
            </div>
            {/* Table rows */}
            {Array.from({ length: count }).map((_, rowIndex) => (
              <div
                key={rowIndex}
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(7, 1fr)',
                  gap: '1rem',
                  padding: '1rem',
                  borderBottom: '1px solid #e5e5e5'
                }}
              >
                {Array.from({ length: 7 }).map((_, colIndex) => (
                  <div key={colIndex} style={{ ...baseStyle, height: '16px' }} />
                ))}
              </div>
            ))}
          </div>
        );

      case 'card':
        return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {Array.from({ length: count }).map((_, i) => (
              <div
                key={i}
                style={{
                  background: 'white',
                  padding: '1.5rem',
                  borderRadius: '10px',
                  boxShadow: '0 2px 10px rgba(0,0,0,0.05)'
                }}
              >
                <div style={{ ...baseStyle, height: '24px', width: '60%', marginBottom: '1rem' }} />
                <div style={{ ...baseStyle, height: '16px', width: '100%', marginBottom: '0.5rem' }} />
                <div style={{ ...baseStyle, height: '16px', width: '80%' }} />
              </div>
            ))}
          </div>
        );

      case 'calendar':
        return (
          <div style={{
            background: 'white',
            padding: '2rem',
            borderRadius: '10px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.05)'
          }}>
            <div style={{ ...baseStyle, height: '32px', width: '200px', marginBottom: '2rem' }} />
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(7, 1fr)',
              gap: '1rem'
            }}>
              {Array.from({ length: 35 }).map((_, i) => (
                <div
                  key={i}
                  style={{
                    ...baseStyle,
                    height: '100px',
                    borderRadius: '8px'
                  }}
                />
              ))}
            </div>
          </div>
        );

      default:
        return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            {Array.from({ length: count }).map((_, i) => (
              <div key={i} style={{ ...baseStyle, height: '20px', width: '100%' }} />
            ))}
          </div>
        );
    }
  };

  return (
    <>
      {renderSkeleton()}
      <style>{`
        @keyframes loading {
          0% {
            background-position: 200% 0;
          }
          100% {
            background-position: -200% 0;
          }
        }
      `}</style>
    </>
  );
};

export default LoadingSkeleton;
